/**
 * Right rail — 320px sticky column shown only on the wide viewport.
 *
 * Pixel-faithful port of `DesktopRightRail` in `screens-web-shell.jsx`.
 * Real data wiring (transactions / analytics) is layered in by Section 14;
 * this iteration uses placeholder copy that mirrors the design source.
 */

export interface RightRailProps {
  /** Optional content; if omitted, renders the design-source placeholder. */
  children?: React.ReactNode;
}

export default function RightRail({ children }: RightRailProps): JSX.Element {
  return (
    <aside
      aria-label="本月概況"
      style={{
        width: 320,
        flexShrink: 0,
        borderLeft: '1px solid var(--border-1)',
        background: 'var(--bg-app)',
        padding: '24px 24px 32px',
        display: 'flex',
        flexDirection: 'column',
        gap: 22,
        height: '100vh',
        overflow: 'auto',
        position: 'sticky',
        top: 0,
      }}
    >
      {children ?? <DefaultPlaceholder />}
    </aside>
  );
}

function DefaultPlaceholder(): JSX.Element {
  return (
    <>
      <div>
        <div
          style={{
            font: '500 11px var(--font-cjk)',
            color: 'var(--fg-3)',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            marginBottom: 10,
          }}
        >
          本月概況
        </div>
        <div
          style={{
            background: 'var(--bg-surface)',
            borderRadius: 14,
            padding: '16px',
            boxShadow: 'var(--shadow-1)',
            border: '1px solid var(--border-1)',
            color: 'var(--fg-3)',
            font: '400 13px var(--font-cjk)',
          }}
        >
          月度結餘將在資料載入後顯示。
        </div>
      </div>

      <div>
        <div
          style={{
            font: '500 11px var(--font-cjk)',
            color: 'var(--fg-3)',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            marginBottom: 10,
          }}
        >
          支出 Top 5
        </div>
        <div
          style={{
            background: 'var(--bg-surface)',
            borderRadius: 14,
            padding: '14px 16px',
            boxShadow: 'var(--shadow-1)',
            border: '1px solid var(--border-1)',
            color: 'var(--fg-3)',
            font: '400 13px var(--font-cjk)',
          }}
        >
          類別排行將在資料載入後顯示。
        </div>
      </div>

      <div
        style={{
          background: 'var(--cream-100)',
          border: '1px solid var(--border-1)',
          borderRadius: 14,
          padding: '14px 16px',
        }}
      >
        <div
          style={{
            font: '600 13px var(--font-cjk)',
            color: 'var(--fg-1)',
            marginBottom: 4,
          }}
        >
          小提示
        </div>
        <div
          style={{
            font: '400 12px/1.55 var(--font-cjk)',
            color: 'var(--fg-2)',
          }}
        >
          按下左側「新增紀錄」，或於手機端用浮動按鈕快速記帳。Mochia 會自動依分類產生月度分析。
        </div>
      </div>
    </>
  );
}
